import * as React from 'react';
import {FlatList, Pressable, StyleSheet, TextInput, TouchableOpacity} from 'react-native';
import { View, Text, Image } from 'react-native';
import {DrawerActions, useNavigation} from "@react-navigation/native";
import {Avatar} from "react-native-paper";
import {windowWidth} from "../utils/Dimentions";
import { Ionicons, Entypo, MaterialCommunityIcons } from '@expo/vector-icons';
import CredentialItem from "../components/CredentialItem";


const data1 = [
    {
        Credential: 'FIRST DEGREE',
        name: 'View Credential',
    }, {
        Credential: 'TRANSCRIPT',
        name: 'View Credential ',
    },{
        Credential: 'COLLEGE',
        name: 'View Credential',
    },{
        Credential: 'GMAT',
        name: 'View Credential',
    },
]

const data2 = [
    {
        Credential: 'GRE',
        name: 'View Credential',
    }, {
        Credential: 'ICAN',
        name: 'View Credential ',
    },{
        Credential: 'NIM',
        name: 'View Credential',
    },{
        Credential: 'PMP',
        name: 'View Credential',
    },
]


export default function StudentProfile() {
    const navigation = useNavigation();
    const userImage = require("../assets/john.png")


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <View style={styles.headerLeft}>
                    <TouchableOpacity>
                        <Ionicons name="search" size={18} color="gray" />
                    </TouchableOpacity>
                    <View>
                        <TextInput style={styles.searchBox} placeholder={"search"}></TextInput>
                    </View>
                </View>
                <View style={styles.headerRight}>
                    <View style={styles.right}>
                        <Ionicons name="notifications" size={18} color="gray" />
                        <View style={styles.lang}>
                            <Text style={styles.text0}>EN</Text>
                            <Entypo name="chevron-down" size={18} color="black" />
                        </View>
                    </View>
                    <View style={styles.left}>
                        <View>
                            <Text style={styles.text1}>John Doe</Text>
                            <Text style={styles.text2}>Oxford University</Text>
                        </View>
                        <TouchableOpacity style={styles.avatar} onPress={() => ({})}>
                            <Avatar.Image
                                source={{uri: userImage}}
                                size={40}
                            />
                        </TouchableOpacity>
                    </View>
                </View>
            </View>

            <View style={styles.mainContainer}>
                <View style={styles.leftContainer}>
                    <View style={styles.upContainer}>
                        <View style={styles.profile}>
                            <Text style={styles.text3}>Kayode Joseph</Text>
                            <Text style={styles.text4}>
                                I'm a Chartered Financial Accountant, providing
                                financial information to management
                                by compiling and presenting reports, budgets,
                                business plans and financial statements
                                (including monthly and annual reports) and
                                auditing financial information.
                            </Text>
                        </View>
                        <View style={styles.imageContainer}>
                            <Image
                                style={styles.image}
                                source={{uri: "https://ath2.unileverservices.com/wp-content/uploads/sites/3/2020/05/360-waves-12.jpg"}}/>
                        </View>
                    </View>
                    <View style={styles.bottomContainer}>
                        <View style={styles.history}>
                            <Text style={styles.text3}>Credentials</Text>
                            <TouchableOpacity>
                                <Text style={styles.text6}>View all</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={styles.historyContainer}>

                            <FlatList
                                data={data1}
                                keyExtractor={({name}) => name }
                                horizontal
                                showsHorizontalScrollIndicator={false}
                                renderItem={({item}) => <CredentialItem Credential={item.Credential} Name={item.name}/>}
                            />

                        </View>
                        <View style={styles.historyContainer}>

                            <FlatList
                                data={data2}
                                keyExtractor={({name}) => name }
                                horizontal
                                showsHorizontalScrollIndicator={false}
                                renderItem={({item}) => <CredentialItem Credential={item.Credential} Name={item.name}/>}
                            />

                        </View>

                    </View>
                </View>
                <View style={styles.rightContainer}>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <MaterialCommunityIcons name="file-certificate" size={20} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Highest Obtained Degree</Text>
                                <Text style={styles.text1}>First Degree</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <Ionicons name="earth" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Country</Text>
                                <Text style={styles.text1}>Nigeria</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <MaterialCommunityIcons name="school" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>University Attended</Text>
                                <Text style={styles.text1}>IIBM Institute of Management</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.boxContainer}>
                        <View style={styles.logoContainer}>
                            <MaterialCommunityIcons name="google-analytics" size={18} color="#2C69C8" />
                            <View style={styles.textContainer}>
                                <Text style={styles.text7}>Cumulative Grade Point</Text>
                                <Text style={styles.text1}>4.88</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.textAnalytics}>
                        <Text style={styles.text1}>Analytics</Text>
                    </View>
                    <View style={styles.graphContainer}>
                        <Image
                            style={styles.graph}
                            source={require('../assets/Chart.png')}/>
                    </View>
                </View>
            </View>

        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: 'white',
    },
    mainContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '95%',
        flex: 1,
        marginBottom: 10,
    },
    leftContainer: {
        height: '100%',
        alignItems: 'center',
        //backgroundColor: 'green',
        justifyContent: 'space-between',
        width: '60%',
    },
    upContainer: {
        height: '30%',
        alignItems: 'center',
        backgroundColor: 'whitesmoke',
        width: '100%',
        borderRadius: 20,
        flexDirection: 'row',
    },
    bottomContainer: {
        height: '67%',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: '100%',
    },
    rightContainer: {
        height: '100%',
        alignItems: 'center',
        backgroundColor: 'whitesmoke',
        width: '35%',
        marginLeft: 50,
        borderRadius: 20,
    },
    header: {
        width: '95%',
        height: 60,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        top: 10,
        marginBottom: 20,
    },
    headerLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
        height: 40,
        borderRadius: 20,
        backgroundColor: 'whitesmoke',
    },
    headerRight: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: '25%',
        height: 40,
        borderRadius: 20,
    },
    searchBox: {
        marginLeft: 20,
        borderWidth: 0,
        height: 25,
        width: 250,
        marginRight: 20,
    },
    lang: {
        flexDirection: 'row',
        marginLeft: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    left: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    right: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    text0: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'black',
        marginRight: 10,
    },
    text1: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
    },
    text2: {
        fontSize: 12,
        color: 'gray',
    },
    textButton: {
        fontSize: 10,
        color: 'whitesmoke',
        fontWeight: '500',
    },
    text3: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
        marginBottom: 10,
    },
    text6: {
        fontSize: 12,
        fontWeight: '500',
        color: 'grey',
    },
    text7: {
        fontSize: 12,
        color: 'black',
    },
    text4: {
        fontSize: 12,
        color: 'black',
        lineHeight: 20,
    },
    text5: {
        fontSize: 14,
        color: 'white',
    },
    avatar: {
        marginLeft: 10,
        marginRight: 10,
    },
    profile: {
        width: '60%',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginLeft: 40,
    },
    button: {
        backgroundColor: 'black',
        height: 30,
        width: 150,
        borderRadius: 7,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
    },
    imageContainer: {
        width: 100,
        marginLeft: 70,
        marginTop: 10,
        marginBottom: 10,
        height: 100,
    },
    image: {
        resizeMode: "cover",
        height: '100%',
        width: '100%',
        borderRadius: 100,
    },
    history: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '90%',
    },
    historyContainer: {
        height: '43%',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        borderRadius: 20,
        flexDirection: 'row',
        marginTop: 10,
    },
    boxContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '75%',
        height: '9%',
        backgroundColor: '#ffffff',
        borderRadius: 10,
        marginTop: 20,
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        shadowColor: 'gray',
        elevation: 2,
    },
    logoContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    textContainer: {
        marginLeft: 20,
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
    },
    textAnalytics: {
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'left',
        width: '75%',
        marginTop: 30,
    },
    graphContainer: {
        alignItems: 'center',
        width: '75%',
        height: '35%',
        borderRadius: 10,
        marginTop: 20,
    },
    graph: {
        resizeMode: 'contain',
        height: '100%',
        width: '100%',
    },
});
